<template>
    <div class="credit-page">
        <div class="top-box">
            <div class="left-box">
                <van-image round width="80" height="80" class="user-img" :error-icon="userDefaultAvatar"
                    :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${userInfo.avatarUrl}`" />
                <img v-if="userInfo.sex === 10" class="sex" src="../assets/man.png" />
                <img v-if="userInfo.sex === 20" class="sex" src="../assets/woman.png" />
            </div>
            <div class="center-box">
                <span class="user-name">{{ userInfo.nickName }}</span>
                <div class="user-tag-box">
                    <span class="user-tag-item" v-for="item in userInfo.labels"
                        :key="'LABEL_USER_ITEM_KEY_' + item.id">{{ item.name }}</span>
                </div>
                <div class="address-box" v-if="
                    userInfo.province || userInfo.city || userInfo.district
                ">
                    <img class="location-icon" src="../assets/location.png" />
                    <span class="user-address">{{ userInfo.province }} {{ userInfo.city }}
                        {{ userInfo.district }}</span>
                </div>
            </div>
            <div class="right-box">
                <span class="label">信誉分</span>
                <span class="value">{{ userInfo.totalCredit }}</span>
            </div>
        </div>
        <div class="session-address">
            <div class="left-box">
                <ul>
                    <li>
                        <div class="icon">
                            <img src="../assets/credit/img_01.png" />
                        </div>
                        <div class="text">
                            <!-- TODO 用户等级 -->
                            <span class="label">暂无</span>
                            <span class="sub">等级</span>
                        </div>
                    </li>
                    <li>
                        <div class="icon">
                            <img src="../assets/credit/img_02.png" />
                        </div>
                        <div class="text">
                            <span class="label">{{
                                userInfo.status === 1 ? "冻结" : "正常"
                                }}</span>
                            <span class="sub">状态</span>
                        </div>
                    </li>
                    <li>
                        <div class="icon">
                            <img src="../assets/credit/img_03.png" />
                        </div>
                        <div class="text">
                            <!-- TODO 用户属性 -->
                            <span class="label">未知</span>
                            <span class="sub">属性</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right-box">
                <img src="@/assets/credit/credit_dan.png" />
            </div>
        </div>
        <div class="session-platform">
            <div class="session-platform-header">
                <span class="label">认证平台</span>
                <span class="sum">({{ platforms.length }})</span>
                <span class="line"></span>
                <img src="../assets/credit/credit_dp.png" />
            </div>
            <div v-if="platforms.length === 0" style="
                    display: flex;
                    padding: 20px;
                    align-items: center;
                    justify-content: center;
                    background: #fafbfb;
                ">
                <span style="color: #aab2b7; font-size: 14px">暂无认证平台</span>
            </div>
            <div v-else class="session-content">
                <div v-for="item in platforms" :key="'PLATFORMS_USER_ITEM_KEY_' + item.id" class="item">
                    <div class="left-box">
                        <img :src="item.platformImg" />
                    </div>
                    <div class="right-box">
                        <span class="name">{{ item.nickName }}</span>
                        <span class="line"></span>
                        <span class="sum">粉丝：{{ item.fans }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="session-quota">
            <div class="row-box">
                <div class="col-box">
                    <div class="left-box">
                        <span class="label">任务量</span>
                        <p>
                            <span class="sum">{{
                                userInfo.taskApplySuccessCount
                                }}</span>
                            <span class="unit">&nbsp;&nbsp;个</span>
                        </p>
                    </div>
                    <div class="right-box">
                        <img src="../assets/credit/credit_xin.png" />
                    </div>
                </div>
                <div class="line"></div>
                <div class="col-box">
                    <div class="left-box">
                        <span class="label">全网粉丝</span>
                        <p>
                            <span class="sum">{{ fansCount }}</span>
                            <span class="unit">&nbsp;&nbsp;{{ fansUnit }}</span>
                        </p>
                    </div>
                    <div class="right-box">
                        <img src="../assets/credit/credit_zhua.png" />
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="row-box">
                <div class="col-box">
                    <div class="left-box">
                        <span class="label">曝光量</span>
                        <p>
                            <span class="sum">{{ creditStatisticsShow }}</span>
                            <span class="unit">&nbsp;&nbsp;{{
                                creditStatisticsShowUnit
                            }}</span>
                        </p>
                    </div>
                    <div class="right-box">
                        <img src="../assets/credit/credit_bgl.png" />
                    </div>
                </div>
                <div class="line"></div>
                <div class="col-box">
                    <div class="left-box">
                        <span class="label">任务完成率</span>
                        <p>
                            <span class="sum">{{ taskFinish }}</span>
                            <span class="unit">&nbsp;&nbsp;%</span>
                        </p>
                    </div>
                    <div class="right-box">
                        <img src="../assets/credit/credit_wcl.png" />
                    </div>
                </div>
            </div>
        </div>
        <div class="session-title">
            <span class="label">信誉分组成</span>
            <span class="line"></span>
            <img src="../assets/credit/credit_dp.png" />
        </div>
        <div class="session-credit">
            <div id="main" class="echart-box"></div>
            <div class="total-credit">
                <span class="value">{{ userInfo.totalCredit }}</span>
                <span class="label">分值</span>
            </div>
        </div>
        <div class="session-title">
            <span class="label">服务品牌</span>
            <span class="sum">({{ userBrands.total }})</span>
            <span class="line"></span>
            <img src="../assets/credit/credit_dp.png" />
        </div>
        <div v-if="userBrands.total === 0" style="
                display: flex;
                padding: 20px;
                align-items: center;
                justify-content: center;
                background: #fafbfb;
            ">
            <span style="color: #aab2b7; font-size: 14px">暂无服务品牌</span>
        </div>
        <div v-else class="session-brand">
            <span class="item" v-for="item in userBrands.records" :key="'USER_BRAND_ITEM_KEY_' + item.id">{{
                item.brandName }}</span>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import {
    fetchPlatforms,
    fetchUsers,
    fetchStatistics,
    fetchUserBrands,
    fetchCreditStatistics,
} from "../services/credit";
import { Toast } from "vant";
import round from "lodash.round";
import Cookies from "js-cookie";
const PLATFROM_ICON = {
    10: require("../assets/credit/icon-xhs.png"),
    20: require("../assets/credit/icon-dy.png"),
    30: require("../assets/credit/icon-ks.png"),
    40: require("../assets/credit/icon-sina.png"),
    50: require("../assets/credit/icon-dzdp.png"),
};
export default {
    name: "Credit",
    data() {
        return {
            userInfo: {
                taskApplySuccessCount: 0,
                taskCompleteCount: 0,
            },
            userDefaultAvatar: require("../assets/user.png"),
            platforms: [],
            statistics: [],
            statisticsOption: {
                tooltip: {
                    show: false,
                    trigger: "item",
                },
                legend: {
                    top: "50",
                    left: "230",
                    orient: "vertical",
                    icon: "circle",
                },
                color: ["#B6B0AD", "#2463F6", "#FFC244", "#FF7F4F"],
                series: [],
            },
            userBrands: {
                records: [],
                total: 0,
            },
            creditStatistics: 0,
            cookieToken: "",
        };
    },
    computed: {
        taskFinish() {
            return round((this.userInfo.taskCompleteRate || 0) * 100, 2);
        },
        fansCount() {
            let result = this.userInfo.fansCount || 0;
            if (result >= 100000 && result < 1000000000) {
                result = round(result / 10000, 1);
            } else if (result >= 1000000000) {
                result = round(result / 100000000, 1);
            }
            return result;
        },
        fansUnit() {
            const result = this.userInfo.fansCount || 0;
            if (result >= 100000 && result < 1000000000) {
                return "万";
            } else if (result >= 1000000000) {
                return "亿";
            }
            return "个";
        },
        creditStatisticsShow() {
            let result = this.creditStatistics;
            if (result >= 100000 && result < 1000000000) {
                result = round(result / 10000, 1);
            } else if (result >= 1000000000) {
                result = round(result / 100000000, 1);
            }
            return result;
        },
        creditStatisticsShowUnit() {
            const result = this.creditStatistics;
            if (result >= 100000 && result < 1000000000) {
                return "万";
            } else if (result >= 1000000000) {
                return "亿";
            }
            return "次";
        },
    },
    mounted() {
        Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
        });
        // Cookies.set('mini-token', '20b178a750334fcc958c0c51b3439b15_app')
        // Cookies.set('mini-secretKey', '809b57317074af0f845cd70c60fce5ce')
        // Cookies.set('token', 'e550f321fa1040b5a022a97712abac07_app')
        // Cookies.set('secretKey', '98ca94eae302495993cc8c2897883650')
        this.checkToRequest();
    },
    methods: {
        checkToRequest() {
            let checkCount = 0;
            const timer = setInterval(async () => {
                const token = Cookies.get("token") || "";
                checkCount++;
                console.log("checkToRequest");
                if (token) {
                    clearInterval(timer);
                    await fetchUsers().then((res) => {
                        this.userInfo = res.data;
                    });
                    await fetchPlatforms().then((res) => {
                        if (res.data.total !== 0) {
                            this.platforms = res.data.records.map((item) => {
                                return {
                                    ...item,
                                    platformImg: PLATFROM_ICON[item.type.value],
                                };
                            });
                        }
                    });
                    await fetchStatistics().then((res) => {
                        res = res.map((item) => {
                            return {
                                value: item.labelTotalCredit,
                                name: item.labelName,
                            };
                        });
                        this.statistics = res;
                        // 基于准备好的dom，初始化echarts实例
                        const myChart = echarts.init(
                            document.getElementById("main")
                        );
                        const legend = {
                            top: "50",
                            left: "230",
                            orient: "vertical",
                            icon: "circle",
                            formatter(name) {
                                const data = res.find(
                                    (item) => item.name === name
                                );
                                console.log("formatter", name, data);
                                return `${data.name}(${data.value})`;
                            },
                        };
                        const series = {
                            name: "",
                            type: "pie",
                            radius: ["40%", "70%"],
                            left: "-35%",
                            // avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: "outside",
                                alignTo: "labelLine",
                                bleedMargin: 10,
                                distanceToLabelLine: 5,
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: "14",
                                    fontWeight: "bold",
                                },
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                                labelLine: {
                                    show: true,
                                },
                            },
                            labelLine: {
                                show: true,
                                showAbove: false,
                                smooth: false,
                                minTurnAngle: 90,
                                maxSurfaceAngle: 90,
                                length: 10,
                                length2: 10,
                                lineStyle: {
                                    width: 1,
                                    type: "solid",
                                },
                            },
                            data: res,
                        };
                        // 绘制图表
                        myChart.setOption({
                            ...this.statisticsOption,
                            legend,
                            series,
                        });
                    });
                    await fetchUserBrands({ size: 999 }).then((res) => {
                        this.userBrands = res.data;
                    });
                    await fetchCreditStatistics().then((res) => {
                        this.creditStatistics = res.data.exposureQuantityCount;
                    });
                    Toast.clear();
                } else {
                    if (checkCount > 10) {
                        Toast.clear();
                        Toast({
                            message: "系统异常，请稍后再试",
                            position: "bottom",
                        });
                        clearInterval(timer);
                    }
                }
            }, 500);
        },
    },
};
</script>

<style scoped lang="less">
.credit-page {

    //background: #FAFBFB;
    /deep/.van-image__error-icon {
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .top-box {
        padding: 20px 20px;
        padding-right: 0;
        display: flex;
        position: relative;

        &:after {
            position: absolute;
            left: 20px;
            right: 20px;
            bottom: 0;
            height: 1px;
            background: #ebebeb;
            content: " ";
        }

        .left-box {
            position: relative;

            .user-img {
                box-shadow: 6px 6px 40px 16px rgba(109, 109, 109, 0.2);
            }

            .sex {
                width: 14px;
                height: 14px;
                background: #ffffff;
                border-radius: 100%;
                position: absolute;
                right: 0;
                padding: 4px;
            }
        }

        .center-box {
            flex: 1;
            padding-left: 24px;

            .user-name {
                font-size: 17px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #171f24;
                line-height: 17px;
            }

            .user-tag-box {
                padding-top: 14px;
                padding-bottom: 10px;

                .user-tag-item {
                    background: #ffffff;
                    box-shadow: 0px 2px 9px -4px rgba(0, 0, 0, 0.5);
                    border-radius: 4px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #eb79ac;
                    line-height: 20px;
                    padding: 0 10px;
                    margin-right: 10px;
                    display: inline-block;
                }
            }

            .address-box {
                display: flex;
                align-items: center;

                .location-icon {
                    margin-right: 10px;
                }

                .user-address {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #aab2b7;
                }
            }
        }

        .right-box {
            width: 93px;
            height: 94px;
            background: #ffffff;
            box-shadow: 0px 2px 27px -11px rgba(109, 109, 109, 0.5);
            border-radius: 13px 0 0 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .label {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #202a58;
            }

            .value {
                font-size: 36px;
                font-family: AvenirNextCondensed-BoldItalic, AvenirNextCondensed;
                font-weight: normal;
                color: #202a58;
                font-style: italic;
            }
        }
    }

    .session-title {
        padding: 13px 20px;
        display: flex;
        align-items: center;

        .label {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        .sum {
            font-size: 10px;
            font-family: PingFangHK-Semibold, PingFangHK;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            margin-top: 6px;
            margin-left: 2px;
        }

        .line {
            display: block;
            flex: 1;
            height: 2px;
            background: #d8d8d8;
            margin: 0 15px;
        }

        img {
            width: 22px;
        }
    }

    .session-address {
        display: flex;
        margin-top: 26px;
        padding: 0 20px;

        .left-box {
            flex: 1;

            ul {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                height: 100%;

                li {
                    padding-left: 10px;
                    display: flex;

                    /*justify-content: space-between;*/
                    .icon {
                        width: 16px;
                        padding: 0;

                        img {
                            width: 16px;
                        }
                    }

                    .text {
                        width: 70px;
                        padding-left: 10px;

                        .label {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 20px;
                            display: block;
                        }

                        .sub {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #6d7278;
                            line-height: 20px;
                        }
                    }
                }
            }
        }

        .right-box {
            width: 224px;

            img {
                width: 224px;
            }
        }
    }

    .session-platform {
        padding-top: 20px;

        .session-platform-header {
            padding: 0 20px;
            display: flex;
            align-items: center;

            .label {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.85);
                line-height: 20px;
            }

            .sum {
                font-size: 10px;
                font-family: PingFangHK-Semibold, PingFangHK;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                margin-top: 6px;
                margin-left: 2px;
            }

            .line {
                display: block;
                flex: 1;
                height: 1px;
                background: #d8d8d8;
                margin: 0 15px;
            }

            img {
                width: 22px;
            }
        }

        .session-content {
            height: 96px;
            overflow-x: auto;
            margin-left: 15px;
            margin-top: 10px;
            display: flex;

            .item {
                width: 310px;
                height: 96px;
                background: #f4f6ff;
                border-radius: 14px;
                display: flex;
                margin-right: 20px;

                .left-box {
                    width: 104px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 46px;
                    }
                }

                .right-box {
                    flex: 1;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .name {
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 22px;
                    }

                    .line {
                        width: 162px;
                        height: 1px;
                        background: #a9b1bd;
                        margin: 5px 0;
                        margin-right: 24px;
                    }

                    .sum {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 20px;
                    }
                }
            }
        }
    }

    .session-quota {
        background: #ffffff;
        border-radius: 16px;
        /*border: 1px solid #D2CFCF;*/
        margin: 34px 15px;
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);

        .line {
            margin: 0 24px;
            height: 1px;
            background: #f7f8f9;
            border-radius: 16px;
        }

        .row-box {
            display: flex;

            .line {
                height: inherit;
                margin: 0;
                width: 1px;
                background: #f7f8f9;
            }

            &:first-child {
                .line {
                    margin-top: 24px;
                }
            }

            &:last-child {
                .line {
                    margin-bottom: 24px;
                }
            }

            .col-box {
                flex: 1;
                /*height: 100%;*/
                display: flex;
                padding: 20px;

                .left-box {
                    flex: 1;

                    .label {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 20px;
                    }

                    .sum {
                        font-size: 24px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 28px;
                    }

                    .unit {
                        font-size: 20px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 28px;
                    }
                }

                .right-box {
                    img {
                        width: 33px;
                    }
                }
            }
        }
    }

    .session-credit {
        background: #ffffff;
        border-radius: 16px;
        margin: 0 15px;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
        position: relative;

        .title {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 20px;
            margin-top: 16px;
            padding-left: 10px;
        }

        .echart-box {
            height: 196px;
        }

        .total-credit {
            position: absolute;
            bottom: 40%;
            left: 28%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .value {
                font-size: 20px;
            }

            .label {
                font-size: 12px;
                color: #d3cfcd;
            }
        }
    }

    .session-brand {
        background: #f4f6ff;
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 12px;
        border-radius: 14px;
        padding: 16px 20px;

        .item {
            background: #ffffff;
            box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.05),
                0px 3px 5px 0px rgba(74, 144, 226, 0.1);
            border-radius: 5px;
            border: 1px solid #5680fa;
            color: #5680fa;
            line-height: 28px;
            padding: 0 14px;
            display: inline-block;
            margin-right: 10px;
            font-size: 12px;
            margin-bottom: 10px;
        }
    }
}
</style>
